"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function tel(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.81 8.6086C19.2847 8.99335 19.584 9.78911 19.479 10.3734L18.459 16.0164C18.3525 16.6044 17.79 17.2516 17.211 17.4549L11.6467 19.4086C11.0677 19.6119 10.2067 19.4649 9.73275 19.0801L5.18925 15.3924C4.7145 15.0076 4.4145 14.2156 4.52175 13.6276L5.54175 7.98461C5.6475 7.39661 6.21 6.75011 6.78975 6.54611L12.3547 4.59161C12.9345 4.38761 13.7947 4.53611 14.2695 4.92011L18.81 8.6086ZM14.0767 11.1421L14.3032 9.99461L12.1792 9.99836L12.4792 8.48635H11.793C11.298 9.24496 10.577 9.82873 9.732 10.1551L9.53925 11.1444H10.4677C10.4677 11.1444 10.1535 12.5649 10.0477 13.0891C9.78525 14.4241 10.4452 15.3706 11.4592 15.3706H13.1752L13.4752 14.1031H12.0397C11.4022 14.1031 11.436 13.7544 11.5597 13.1356L11.955 11.1391L14.0767 11.1421Z", fill: color }));
}
exports["default"] = tel;
//# sourceMappingURL=tel.js.map